const requiredProfileFields: Array<keyof API.ProfileInfo> = [
  'firstNameRoma',
  'lastNameRoma',
  'firstNameKana',
  'lastNameKana',
  'firstNameKanji',
  'lastNameKanji',
  'birthday',
  'gender',
  'postalCode',
  'address',
  'mobile',
  'mailAddress',
  'nationality',
  'visaType',
  'visaFromDate',
  'visaToDate',
];

const hasValue = (value: unknown) => {
  if (value === null || value === undefined) return false;
  return String(value).trim() !== '';
};

export const isProfileComplete = (profile?: API.ProfileInfo | null) => {
  if (!profile) return false;
  return requiredProfileFields.every((field) => hasValue(profile[field]));
};
